export var single = [
    {
      "name": "Helmet",
      "value": 100
    },
    {
      "name": "Jacket",
      "value": 50
    },
    {
      "name": "Intrusion",
      "value": 25
    },
    {
      "name": "Fire /Smoke",
      "value": 0
    }
  ];

  export var sample = [
    {
      "name": "Helmet",
      "value": 8940000
    },
    {
      "name": "Jacket",
      "value": 5000000
    },
    {
      "name": "Intrusion",
      "value": 7200000
    },
    {
      "name": "UK",
      "value": 5200000
    },
    {
      "name": "Italy",
      "value": 7700000
    },
    {
      "name": "Spain",
      "value": 4300000
    }
  ];

  export var multi = [
    {
      "name": "Helmet",
      "series": [
        {
          "value": 50,
          "name": "2016-09-14T02:28:09.498Z"
        },
        {
          "value": 45,
          "name": "2016-09-18T00:09:45.052Z"
        },
        {
          "value": 65,
          "name": "2016-09-14T21:38:31.868Z"
        },
        {
          "value": 60,
          "name": "2016-09-20T19:55:25.121Z"
        },
        {
          "value": 42,
          "name": "2016-09-13T21:49:25.412Z"
        }
      ]
    },
    {
      "name": "Jacket",
      "series": [
        {
          "value": 23,
          "name": "2016-09-14T02:28:09.498Z"
        },
        {
          "value": 26,
          "name": "2016-09-18T00:09:45.052Z"
        },
        {
          "value": 59,
          "name": "2016-09-14T21:38:31.868Z"
        },
        {
          "value": 63,
          "name": "2016-09-20T19:55:25.121Z"
        },
        {
          "value": 40,
          "name": "2016-09-13T21:49:25.412Z"
        }
      ]
    },
    {
      "name": "Intrusion",
      "series": [
        {
          "value": 40,
          "name": "2016-09-14T02:28:09.498Z"
        },
        {
          "value": 52,
          "name": "2016-09-18T00:09:45.052Z"
        },
        {
          "value": 58,
          "name": "2016-09-14T21:38:31.868Z"
        },
        {
          "value": 49,
          "name": "2016-09-20T19:55:25.121Z"
        },
        {
          "value": 34,
          "name": "2016-09-13T21:49:25.412Z"
        }
      ]
    },
    {
      "name": "Smoke",
      "series": [
        {
          "value": 0,
          "name": "2016-09-14T02:28:09.498Z"
        },
        {
          "value": 2,
          "name": "2016-09-18T00:09:45.052Z"
        },
        {
          "value": 0,
          "name": "2016-09-14T21:38:31.868Z"
        },
        {
          "value": 1,
          "name": "2016-09-20T19:55:25.121Z"
        },
        {
          "value": 0,
          "name": "2016-09-13T21:49:25.412Z"
        }
      ]
    },
    {
      "name": "Fire",
      "series": [
        {
          "value": 0,
          "name": "2016-09-14T02:28:09.498Z"
        },
        {
          "value": 0,
          "name": "2016-09-18T00:09:45.052Z"
        },
        {
          "value": 0,
          "name": "2016-09-14T21:38:31.868Z"
        },
        {
          "value": 1,
          "name": "2016-09-20T19:55:25.121Z"
        },
        {
          "value": 0,
          "name": "2016-09-13T21:49:25.412Z"
        }
      ]
    }
  ];
  

  export interface PeriodicElement {
    name: string;
    position: number;
    device: string;
    count: number;
  }
  
  export var ELEMENT_DATA: PeriodicElement[] = [
    {position: 1, name: 'cam1', device: "apx", count: 20 },
    {position: 2, name: 'cam2', device: "apx", count: 25},
    {position: 3, name: 'cam3', device: "office", count: 50},
    {position: 4, name: 'cam4', device: "office", count: 15},
    {position: 5, name: 'cam5', device: "office", count: 0},
    {position: 6, name: 'cam6', device: "site1", count: 65},
    {position: 7, name: 'cam20', device: "site1", count: 8},
    {position: 8, name: 'cam80', device: "site1", count: 22},
    {position: 9, name: 'cam_a', device: "site2", count: 11},
    {position: 10, name: 'cam_rt', device: "workloc", count: 5},
  ];